import { documentService, masterDataService, defaultParams } from 'services'

export const paymentApi = async ({ invoiceNo, encryptedCardInfo }) => {
  return documentService({
    method: 'post',
    url: '/paymentGateway/payment',
    data: {
      invoiceNo,
      encryptedCardInfo,
    },
  })
}

export const paymentAlternativeApi = async ({ invoiceNo, paymentChannel }) => {
  return documentService({
    method: 'post',
    url: '/paymentGateway/paymentToken',
    data: {
      invoiceNo,
      paymentChannel,
    },
  })
}

export const getSavedPaymentCardApi = async stakeholderId => {
  return masterDataService({
    method: 'post',
    url: '/paymentAccount/query',
    data: {
      where: [
        {
          ...defaultParams,
          // stakeholderId,
          filter: 'my-payment-account',
        },
      ],
    },
  })
}
